module.exports = __webpack_public_path__ + "img/digitable-menu.5feb95f5.png";